export default __webpack_public_path__ + "static/media/paypal-white.5458a680.png";